import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaSignOutAlt } from "react-icons/fa";
import { PiUserCircleDuotone } from "react-icons/pi";
import API from "../../Utils/api";
import logo from "../../Assets/logo.png";

const AuthNavbar = ({ setIsSidebarOpen }) => {
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [admin, setAdmin] = useState(null);
  const dropdownRef = useRef();

  useEffect(() => {
    const fetchAdmin = async () => {
      try {
        const adminId = localStorage.getItem("adminId");
        const token = localStorage.getItem("token");

        console.log("adminId:", adminId);
        console.log("token:", token);

        if (!adminId || adminId === "null") {
          console.log("Admin ID missing, skipping API call");
          return;
        }

        const res = await API.get(`/admins/get-admin-by-id/${adminId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        console.log("API Response:", res.data);

        setAdmin(res.data.admin);
      } catch (error) {
        console.log("Error fetching admin:", error);
      }
    };

    fetchAdmin();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    // localStorage.removeItem("adminInfo");
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <nav className="bg-white shadow-lg fixed top-0 w-full p-2 z-50">
      <div className="px-4 flex justify-between items-center">
        {/* Logo */}
        <img
          src={logo}
          alt="logo"
          className="w-12 cursor-pointer"
          onClick={() => setIsSidebarOpen((prev) => !prev)}
        />

        {/* Profile Section */}
        <div className="relative" ref={dropdownRef}>
          <div
            className="flex items-center gap-2 cursor-pointer"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            {admin?.profilePic ? (
              <img
                src={admin.profilePic}
                alt="profile"
                className="w-10 h-10 rounded-full object-cover border"
              />
            ) : (
              <PiUserCircleDuotone size={40} />
            )}

            <span className="text-base text-black hidden md:block">
              {admin?.name || "Admin"}
            </span>
          </div>

          {/* Dropdown */}
          {isDropdownOpen && (
            <div className="absolute right-0 mt-3 w-64 bg-white rounded-xl shadow-xl border p-4">
              <div className="flex flex-col items-center">
                {admin?.profilePic ? (
                  <img
                    src={admin.profilePic}
                    alt="profile"
                    className="w-16 h-16 rounded-full object-cover border"
                  />
                ) : (
                  <PiUserCircleDuotone size={60} />
                )}

                <h3 className="mt-2 font-semibold">{admin?.name || "Admin"}</h3>

                <p className="text-sm text-gray-500">
                  {admin?.email || "No Email"}
                </p>
              </div>

              <div className="border-t my-3"></div>

              <button
                onClick={handleLogout}
                className="w-full py-2 mt-2 rounded bg-red-500 text-white flex items-center justify-center gap-2"
              >
                <FaSignOutAlt />
                Sign Out
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default AuthNavbar;
